import React, { Component } from "react";
import PropTypes from "prop-types";

import { ScoreboardPositionPicker, SponsorUpload, ScoreboardTeamEdit } from "../../..";
import Footer from "./Footer";
import "./ScoreboardSettings.scss";
class ScoreboardSettings extends Component {
  static propTypes = {
    isDigitalScore: PropTypes.bool,
    liveId: PropTypes.string,
    onApplyChanges: PropTypes.func,
    onRemoveTeamColorAndImage: PropTypes.func,
    swapScoreboardToVideoView: PropTypes.func,
    teamResources: PropTypes.object
  }

  static defaultProps = {
    isDigitalScore: false,
    liveId: "",
    onApplyChanges: ()=> {},
    onRemoveTeamColorAndImage: () => {},
    swapScoreboardToVideoView: ()=> {},
    teamResources: null
  }

  state = {
    awayName: "",
    homeName: "",
    awayLogo: "",
    homeLogo: "",
    location: "",
    sponsorLogo: "",
    awayColor: "",
    homeColor: "",
    showLoader: false
  }

  componentDidMount() {
    const { teamResources } = this.props;
    this.setState({
      ...teamResources
    });
  }

  componentDidUpdate(prevProps) {
    const { teamResources } = this.props;
    if(teamResources && prevProps.teamResources !== teamResources) {
      const { awayLogo, awayName, homeLogo, homeName, location, sponsorLogo, homeColor, awayColor } = teamResources;
      this.setState({
        awayLogo,
        awayName,
        homeLogo,
        homeName,
        location,
        sponsorLogo,
        homeColor,
        awayColor
      });
    }
  }

  handleScoreboardLocationChange = location => {
    this.setState({
      location
    });
  };

  handleHomeNameChange = event => {
    this.setState({
      homeName: event.target.value
    });
  };

  handleAwayNameChange = event => {
    this.setState({
      awayName: event.target.value
    });
  };

  handleHomeImageSave = image => {
    this.setState({
      homeLogo: image,
      homeColor: ""
    })
  }

  handleAwayImageSave = image => {
    this.setState({
      awayLogo: image,
      awayColor: ""
    });
  };

  handleSponsorImageSave = image => {
    this.setState({
      sponsorLogo: image
    });
  }

  handleHomeColorChange = color => {
    this.setState({
      homeColor: color,
      homeLogo: ""
    });
  }

  handleAwayColorChange = color => {
    this.setState({
      awayColor: color,
      awayLogo: ""
    });
  }

  handleApplyChanges = async ()=> {
    const { onApplyChanges } = this.props;
    const { homeColor, homeLogo, awayColor, awayLogo } = this.state;
    const changes = { ...this.state }
    changes.homeLogo = homeLogo || homeColor;
    changes.awayLogo = awayLogo || awayColor;
    this.setState({ showLoader: true });
    await onApplyChanges({ ...changes });
    this.setState({ showLoader: false });
  }

  handleRemoveTeamColorAndImage = async isHomeTeam => {
    const { onRemoveTeamColorAndImage } = this.props;
    this.setState({ showLoader: true });
    await onRemoveTeamColorAndImage(isHomeTeam);
    this.setState({ showLoader: false });
  }

  render() {
    const { onRemoveScoreboardSponsor, isDigitalScore } = this.props;
    const { awayLogo, awayName, homeLogo, homeName, location, sponsorLogo, awayColor, homeColor, showLoader } = this.state;

    return (
      <div className="scoreboard-settings">
        {isDigitalScore &&
          <div className="scoreboard-settings__teams">
            <ScoreboardTeamEdit
              logo={homeLogo}
              name={homeName}
              color={homeColor}
              handleNameChange={this.handleHomeNameChange}
              handleImageSave={this.handleHomeImageSave}
              handleColorChange={this.handleHomeColorChange}
              onRemoveTeamColorAndImage={this.handleRemoveTeamColorAndImage}
              isHomeTeam
            />
            <ScoreboardTeamEdit
              logo={awayLogo}
              name={awayName}
              color={awayColor}
              handleNameChange={this.handleAwayNameChange}
              handleImageSave={this.handleAwayImageSave}
              handleColorChange={this.handleAwayColorChange}
              onRemoveTeamColorAndImage={this.handleRemoveTeamColorAndImage}
              isHomeTeam={false}
            />
          </div>
        }
        <div className="scoreboard-settings__position">
          <ScoreboardPositionPicker selected={location} onSelect={this.handleScoreboardLocationChange}/>
        </div>
        {isDigitalScore &&
          <div className="scoreboard-settings__sponsor">
            <SponsorUpload
              title="Add sponsor logo"
              image={sponsorLogo}
              aspectRatio={324 / 50}
              cropperStyles={{height: 315, width: 560}}
              onSave={this.handleSponsorImageSave}
              onRemoveLogo={onRemoveScoreboardSponsor}
            />
          </div>
        }
        <div className="scoreboard-settings__footer">
          <Footer
            onClick={this.handleApplyChanges}
            showLoader={showLoader}
          />
        </div>
      </div>
    )
  }
}

export default ScoreboardSettings;
